$(document).ready(function () {
    // Function to add the HTML content after 5 seconds
    function addHtmlContent() {
        // HTML content to be added
        const htmlContent1 = `
            <p style="font-size: 14px; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; font-weight: 400; text-align: center;">
                <span class="ql-font-bebas-neue" style="font-size: 63px; color: #1c314e; font-family: 'Bebas Neue', Helvetica, Arial, sans-serif; font-weight: bold;">
                    Get <span style="color: #d36548;">20
                        <span class="ql-font-bebas-neue" style="font-size: 63px; color: #1c314e; font-family: 'Bebas Neue', Helvetica, Arial, sans-serif; font-weight: bold;">
                            <span style="color: #d36548;">%</span>
                        </span>
                    OFF <span style="color: #1c314e;">Your First Order</span>
                </span>
            </span>
            </p>`;
        const htmlContent2 = `<p style="font-size: 14px; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; font-weight: 400; text-align: center;"><span class="ql-font-arial" style="font-size: 20px; color: #1c314e; font-family: 'Plus Jakarta Sans', Helvetica, Arial, sans-serif; font-weight: 600;">First time customer? Join our newsletter and get 20% off your first order.<br></span></p>`

        // Append the HTML content to the element with ID #rich-text-016JB91TTR00000000001XE88H
        $('#rich-text-016JB91TTR00000000001XE88H').html(htmlContent1);
        $('#rich-text-016JB91TTR00000000001XE88J').html(htmlContent2);
        let test = $('button.needsclick.go809051785.kl-private-reset-css-Xuajs1').html();
        if (test == "CLAIM MY 30% OFF!") {

            setTimeout(function () {
              
                $("button:contains('CLAIM MY 30% OFF!')").first().html("CLAIM MY 30% OFF!");

            }, 1000);
        }
    }

    // Function to check if the klaviyo-form class exists
    function checkForKlaviyoForm() {
        if ($('.klaviyo-form').length > 0) {
            // If klaviyo-form exists, add HTML content after 5 seconds
            addHtmlContent();
            return true;
        }
        return false;
    }

    // Create an observer to watch for changes in the DOM
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (checkForKlaviyoForm()) {
                observer.disconnect(); // Stop observing once the klaviyo-form is found
            }
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial check in case the class is already present
    checkForKlaviyoForm();
    let trustpilotData = localStorage.getItem('trustpilotData');
    trustpilotData = JSON.parse(localStorage.getItem('trustpilotData'));
    if (trustpilotData) {
        let reviewsCount = trustpilotData.totalReviews;
        let overallRating = trustpilotData.overallRating;
        console.table(trustpilotData)
        $('.tb-content').html(`
            <div>
                <img class="star-image" src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-4.5.svg" width="131px" alt="Star rating">
            </div>
            <div>Rated ${overallRating} out of 5 based on ${reviewsCount} Reviews <div/>
        `)

        $('.tb-content-2').html(`
        
            <div>Rated ${overallRating} out of 5 based on ${reviewsCount} Reviews <div/>
        `)
        $('.rating-hit.five-star').text(`${trustpilotData.other.businessEntity.numberOfReviews.fiveStars}`);
        $('.rating-hit.four-star').text(`${trustpilotData.other.businessEntity.numberOfReviews.fourStars}`);
        $('.rating-hit.three-star').text(`${trustpilotData.other.businessEntity.numberOfReviews.threeStars}`);
    }
    // Function to get options values and store in an array
    function getDogNamesList() {
        // Initialize an empty array
        var optionsValues = [];
        // Iterate over each option in the select element
        $('.dog-breeds-list option').each(function () {
            // Push the value of each option to the array
            optionsValues.push($(this).val());
        });
        // Return the array of options values
        return optionsValues;
    }

    if ($('#dog-breed').length > 0) {

        $("#dog-breed").autocomplete({
            source: getDogNamesList(),
        });
    }

    function convertName(fullName) {
        // Split the full name by spaces
        const nameParts = fullName.trim().split(' ');

        // Get the first name
        if (nameParts.length > 1) {
            const firstName = nameParts[0];
            // Get the initial of the last name
            const formattedName = `${firstName}`;
            return formattedName;
        }

    }
    // Add click event listener to .addMorecloseIcon
    $(document).on('click', '.addMorecloseIcon, .skip_add_goat_mik', function () {

        window.location.href = '/cart'
    })

    $(document).on('click', '.add-another-dog-btn', function () {

        $("add-more-confirmation, cart-drawer").remove();
        $(".product-form__submit.button:visible").trigger("click");
        // Remove the "dogInformation" key from localStorage
        let data = JSON.parse(localStorage.getItem("dogInformation"));

        if (data) {

            data.currentStep = 1

            let quizDataEmail = data.yourInfo.email;
            let quizDataName = data.yourInfo.yourName;
            localStorage.setItem('quizDataEmail', quizDataEmail);
            localStorage.setItem('quizDataName', quizDataName);

            localStorage.setItem("dogInformation", JSON.stringify(data))
        }
        //redirect to quiz after 2 seconds
        setTimeout(() => {
            window.location.href = '/pages/quiz'
        }, 2000);
        // window.location.href = '/pages/quiz'
    })

    $(document).on('click', '.quiz_nextStepButton', function () {

        if (localStorage.getItem('quizDataEmail') && localStorage.getItem('quizDataName')) {

            $("#your-name").val(localStorage.getItem('quizDataName'));
            $("#your-email").val(localStorage.getItem('quizDataEmail'));
        }
    })


    $(function () {
        if ($(".quiz_prevStepButton").length > 0) {

            $(document).tooltip();
        }
    });

    $(document).on('click', '.add_another_dog', function () {
        $(".product-form__submit.button:visible").attr("add-another-dog", "true").trigger("click");
        $(".product-form__submit.button:visible").trigger("click");
    });

    $(document).on('click', '.gm_add_to_order', function (e) {
        e.preventDefault();
        $(this).text("Loading...");
        if (!($("#checkbox").is(':checked'))) {
            $(".umalAddtoOrder").trigger("click");

        }
        if ($(this).hasClass("add_gm_to_every_order")) {

            //add_gm_to_every_order
            $("#button2").removeAttr("checked");
            $("#button2").prop("checked", false);

            $("#button1").attr("checked", '');
            $("#button1").prop("checked", true);
        }
        if ($(this).hasClass("add_gm_to_order")) {
            //add_gm_to_order
            $("#button1").removeAttr("checked");
            $("#button1").prop("checked", false);

            $("#button2").attr("checked", '');
            $("#button2").prop("checked", true);

        }
        $("input[name='submit_next_button']").trigger("click");
    });
    //shuffle review code starts
    function shuffleElements(keepFirstTwo = false, parentSelector = '.slick-track') {
        // Select the parent element
        var $parent = $(parentSelector);

        // Select all child elements
        var $children = $parent.children('.slick-slide');

        if (keepFirstTwo) {
            // Separate the first two child elements
            var $firstTwo = $children.slice(0, 2);
            var $toShuffle = $children.slice(2);

            // Shuffle the remaining child elements
            var shuffled = $toShuffle.sort(function () {
                return 0.5 - Math.random();
            });

            // Clear the parent element
            $parent.empty();

            // Append the first two child elements back to the parent
            $parent.append($firstTwo);

            // Append the shuffled child elements back to the parent
            $parent.append(shuffled);
        } else {
            // Shuffle all child elements
            var shuffled = $children.sort(function () {
                return 0.5 - Math.random();
            });

            // Clear the parent element
            $parent.empty();

            // Append the shuffled child elements back to the parent
            $parent.append(shuffled);
        }
    }

    let keepFirstTwo = false;
    if ($(".ck-custom-reviews-section").length) {

        keepFirstTwo = false;
    }
    window.shuffleReviews = shuffleElements;
    // Call the function to shuffle elements on page load with the parameter
    shuffleElements(keepFirstTwo);
    //shuffle review code ends

    function ImproveQuizProductPageBtnFreqClickEffect() {
        let url  = window.location.href;
        if(url.includes('/quiz-product')){
            $(document).on('click', '.delivery-button:visible', function () {
                console.log("clicked on delivery button");
                //remve the class
                $('.delivery-button:visible').removeClass('active');
                $(this).addClass('active');
            })
        }
    }
    // ImproveQuizProductPageBtnFreqClickEffect();

});